export default __webpack_public_path__ + "static/media/questions.b68ae471.png";